import { Industries } from '@/domain/products/types';
import { registerResetFn } from '@/store/reset';
import { create } from 'zustand';

import { type Filter, type Filters, type ShowType } from '../types';

export interface SolutionStore {
  showType: ShowType[];
  industry: Industries;
  searchValue: string;
  filtersValue: Filters[];
  filters: Filter[];
  isSidebarOpen: boolean;
  layout: 'card' | 'grid';
  selectedProductId: number | null;
}

const initialState: SolutionStore = {
  showType: ['Show Solutions'],
  industry: Industries.ALL_SOLUTIONS,
  searchValue: '',
  filtersValue: [],
  filters: [],
  isSidebarOpen: true,
  layout: 'card',
  selectedProductId: null,
};

export const useSolutionStore = create<SolutionStore>()(() => ({ ...initialState }));

registerResetFn(() => useSolutionStore.setState(initialState));

export const addFilter = (value: Filter) =>
  useSolutionStore.setState((state) => ({ filters: [...state.filters, value] }));

export const clearFilters = () =>
  useSolutionStore.setState((state) => (state.filters.length === 0 ? state : { filters: [] }));

export const removeFilter = (value: Omit<Filter, 'name'>) =>
  useSolutionStore.setState((state) => ({
    filters: state.filters.filter((f) => !(f.id === value.id && f.group === value.group)),
  }));

export const setFilter = (value: Filter) =>
  useSolutionStore.setState((state) => ({
    filters: [...state.filters.filter((f) => f.group !== value.group), value],
  }));
